import { render, staticRenderFns } from "./ReceiptsTable.vue?vue&type=template&id=5264647e&scoped=true&"
import script from "./ReceiptsTable.vue?vue&type=script&lang=js&"
export * from "./ReceiptsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsTable.vue?vue&type=style&index=0&id=5264647e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264647e",
  null
  
)

export default component.exports